/**
 * Determines the number of decimal places in a number
 * @param num - The number to analyze
 * @returns The number of decimal places
 */
export const getDecimalPlaces = (num: number): number => {
  if (Number.isInteger(num)) return 0;
  return num.toString().split('.')[1]?.length || 0;
};
